import {RestProvider} from './coreApiDataProvider'
import {getDataProviderMap} from "../utils/getDataProviderMap";
import {dataProviderConfig} from "../config/dataProvidersConfig";

export const loadBiddingApiDataProvider = (type, resource, params) => {
    const apiUrl = dataProviderConfig.loadBiddingApiDataProvider;
    const provider = {...RestProvider(apiUrl)};
    const providerMap = getDataProviderMap(provider, resource, params);
    return providerMap.get(type)(resource, params);
};